import { theme as antdTheme, Typography } from 'antd';
import type { ReactNode } from 'react';

interface Props {
  primary: ReactNode;
  secondary?: ReactNode;
  hint?: ReactNode;
}

export function FormActionBar({ primary, secondary, hint }: Props) {
  const { token } = antdTheme.useToken();
  return (
    <div
      style={{
        position: 'sticky',
        bottom: 0,
        marginInline: -28,
        marginBlockEnd: -24,
        marginBlockStart: 8,
        padding: '14px 28px',
        background: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        boxShadow: '0 -4px 14px rgba(0,0,0,0.04)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        zIndex: 5,
      }}
    >
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>{hint}</Typography.Text>
      <div style={{ display: 'flex', gap: 8 }}>
        {secondary}
        {primary}
      </div>
    </div>
  );
}
